import { formatMoney } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const orderRefsWithPrincipalAmountMobile = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'status',
    headerName: <Text tId={'ORDER_REFERENCE'} />,
    renderCell: (rowData) => {
      const { palette } = useCustomTheme();
      return (
        <div className={'overflow-text-ellipsis'}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Font color="textPrimary" variant="caption">
              <strong>{formatMoney(amountToValueMoneyMapper(rowData.row.principal))}</strong>
            </Font>
          </div>
          <div className="overflow-text-ellipsis" style={{ color: palette.text.secondary }}>
            Ref: {rowData.row.cart.merchantOrderReference1}
          </div>
          <div className="overflow-text-ellipsis" style={{ color: palette.text.secondary }}>
            <Font color="textSecondary" variant="caption">
              Ref #2: {rowData.row.cart.merchantOrderReference2}
            </Font>
          </div>
        </div>
      );
    },
  };
};
